/**
 * @generated SignedSource<<565c663c44a83fd0678e8c9bcb572365>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InlineContentHeroButtonsFragment$data = {
  readonly attachments: {
    readonly totalCount: number;
  };
  readonly coverPhoto: string | null;
  readonly coverVideo: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"InlineContentAttachmentsSectionFragment">;
  readonly " $fragmentType": "InlineContentHeroButtonsFragment";
};
export type InlineContentHeroButtonsFragment$key = {
  readonly " $data"?: InlineContentHeroButtonsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"InlineContentHeroButtonsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InlineContentHeroButtonsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentAttachmentNodeConnection",
      "kind": "LinkedField",
      "name": "attachments",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "coverPhoto",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "coverVideo",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InlineContentAttachmentsSectionFragment"
    }
  ],
  "type": "Content",
  "abstractKey": null
};

(node as any).hash = "7c3908a12ec142371222dc170c2de16d";

export default node;
